// Only editor text belongs in the generation context; action data stays local.
export const existingTemplateDraft = fields => {
  const limits = {
    name: 100,
    body: 1024,
    header: 60,
    footer: 60,
    action_text: 25,
  };
  const draft = {};
  Object.entries(limits).forEach(([key, limit]) => {
    const text = Array.from(String(fields[key] || '').trim())
      .slice(0, limit)
      .join('');
    if (text) draft[key] = text;
  });
  const labels = (fields.button_texts || [])
    .filter(text => typeof text === 'string' && text.trim())
    .slice(0, 10)
    .map(text => Array.from(text.trim()).slice(0, 25).join(''));
  if (labels.length) draft.button_texts = labels;
  return draft;
};
